<ion-page>
  <ion-content class="fade-slide-enter">
    <div class="page-shell">
      <div class="layout">
        <app-back-button></app-back-button>

        <div class="page-header">
          <h1 class="page-title">Cookie settings</h1>
          <p class="subtitle">Control advertising and analytics while keeping essentials enabled.</p>
        </div>

        <div class="glass-card settings-card">
          <div class="preference essential">
            <div>
              <p class="pref-title">Essential cookies</p>
              <p class="muted">Authentication, security, availability. Required to run Tubify.</p>
            </div>
            <div class="locked">Always on</div>
          </div>

          <div class="preference">
            <div>
              <p class="pref-title">Advertising (Adsterra)</p>
              <p class="muted">Enables monetized banners. No YouTube or Spotify data is shared with Adsterra.</p>
            </div>
            <ion-toggle [(ngModel)]="prefs.ads" mode="ios"></ion-toggle>
          </div>

          <div class="preference">
            <div>
              <p class="pref-title">Analytics</p>
              <p class="muted">Helps us improve Tubify with privacy-aware usage metrics.</p>
            </div>
            <ion-toggle [(ngModel)]="prefs.analytics" mode="ios"></ion-toggle>
          </div>

          <div class="actions">
            <ion-button class="futuristic-button" (click)="save()">Save preferences</ion-button>
            <ion-button fill="clear" class="ghost" (click)="reject()">Reject Non-Essential</ion-button>
            <ion-button fill="outline" class="secondary" (click)="acceptAll()">Accept All</ion-button>
          </div>

          <div class="links">
            <a routerLink="/terms">Terms of use</a>
            <a routerLink="/privacy">Privacy Policy</a>
          </div>
        </div>
      </div>
    </div>
  </ion-content>
</ion-page>
